import React from 'react';
import styled from 'styled-components';
import ChevRightSvg from '../../images/chevron-right.inline.svg';
import Link from '../Link';
// Headers for "Most Recent Posts" side modul on Post pages;
const categoryHeaders = {
	'Jump the Phone Queue for Any Company': 'DoNotWait: Jump the Phone Que of These Companies',
	'Help With Bills': 'Lower These Bills With DoNotPay',
	'Airline Flight Compensation Hacks': 'Get Your Money Back For Canceled or Rescheduled Flights',
	"Get Free Trials & Don't Get Charged": 'Genuinely Free Free Trials',
	'Appeal Parking Tickets': 'Contest Parking Tickets Anywhere in the U.S.',
	'Schedule Appointments With the DMV': 'Step-By-Step Guides to All Things Driving',
	'Robocall Compensation': 'Revenge Against the Machine—Make Robocalls Pay',
	'Burner Phones': 'Don’t Give These Companies Your Actual Phone Number',
	'Cancel A Subscription': 'Cancel Subscriptions Quickly and Save Hundreds of Dollars',
	'Chargebacks and Refunds': 'Make These Companies Give You Your Money Back',
	'Clinical Trials': 'Discover Best-Paid Clinical Trials Near You',
	'College Fee Waivers': 'Lower the Application Fee & Get Into Your Favorite College',
	'Compensation for Victims of Crime': 'Get the Compensation You Deserve',
	'Connect With an Inmate': 'Reach Inmates in any State Quick & Easy',
	'Copyright Protection': 'Copyright Your Content and Keep It 100% Protected',
	'Credit Cards': 'Avoid Unwanted Charges With Top Virtual Credit Cards',
	'Child Travel Consent Form': 'Handle Child Consent Form Bureaucracy the Easy Way',
	'Fight Email Spam': 'Never Read Another Unwanted Email',
	'Fight Text Spam': 'Never Get Another Text From Unwanted Senders',
	'Find Unclaimed Money': 'Discover "Where Yo Money At"',
	'Freedom of Information Act': 'FOIA Requests, Forms, and Regulations Explained',
	'Fight Workplace Discrimination': 'Ensure Fair Treatment at Work',
	'Free Raffle Tickets': 'Enter Any Raffle in Seconds to Win $$$',
	'Government Tests': 'Know the Right Answer to Every Question',
	'Insurance Claims': 'File Any Type of Insurance Claim In Minutes',
	'Late Delivery Refunds': 'Never Pay for Damaged Goods and Late Deliveries Again',
	'Mailing as a Service': 'All You Need To Know to Send Anything Anywhere',
	'Neighbor Complaints': 'How To Deal With Annoying Neighbors & Get Some Peace of Mind',
	'Notarize Documents': 'Get Your Documents Notarized With a Single Click',
	'Online Fax': 'Discover the Best Ways to Send Faxes Online',
	'Reducing Property Taxes': 'Bulletproof Ways To Reduce Property Taxes',
	'Stalking and Harassment': 'Make Sure Stalkers Stay Far Enough Away',
	'Standardized Legal Documents': 'Legal Documents Deciphered: Guides, How Tos, Drafts, and More',
	'Sue Anyone in Small Claims Court': 'Sue These Companies and Win!',
	'Warranty Claims': 'Don’t Buy the New—Claim a Warranty and Fix the Old',
	'HR Complaints': 'Raise the Issue With HR Without Fear of Repercussions',
	'Item Return Requests': 'Return any Item You Don’t Want & Get Your Money Back',
	'Financial Power of Attorney': 'Draft Futureproof Power of Attorney Documents In Seconds',
};

const ReccentPostWidget = styled.div`
	border-bottom: 1px solid #ced8e1;
	margin-bottom: 35px;
	padding-bottom: 40px;
`;
const RecentPostTitle = styled.h4`
	color: #19214b;
	font-weight: 700;
	font-size: 16px;
	margin: 0 0 15px 0;
`;
const List = styled.div``;
const ListItem = styled.div`
	margin-bottom: 9px;
	:last-child {
		margin-bottom: 0;
	}
	> a {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		color: #99aabbef;
		font-weight: 500;
		transition: all 0.3s ease-in-out 0s;
		text-decoration: none;

		> div {
			border: 1px solid transparent;
			border-radius: 50%;
			width: 27px;
			height: 27px;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: all 0.3s ease-in-out 0s;
			margin-left: 8px;

			> div {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 90%;
				height: 90%;
				border-radius: 50%;

				> svg {
					width: 15px;
					height: 15px;
				}
			}
		}

		> div {
			min-width: 27px;
		}

		&:hover {
			color: #661271;

			> div {
				background-image: linear-gradient(90deg, #661271 100%, #5a35f2 0%);
				> div {
					background-color: #fff;
				}
			}
		}
	}
`;

const ChevRight = styled.img``;

export default function RecentPostsSameCategory({ recentPosts, category }) {
	if (!recentPosts) {
		return null;
	}

	return (
		<ReccentPostWidget>
			<RecentPostTitle>{categoryHeaders[category] ? categoryHeaders[category] : 'Relevant posts'}</RecentPostTitle>
			<List>
				{recentPosts.map(({ node }) => {
					return (
						<ListItem key={node.id}>
							<Link noPrefetch to={`/${node.slug}/`}>
								<span>{node.title}</span>
								<div>
									<div>
										<ChevRight src={ChevRightSvg} />
									</div>
								</div>
							</Link>
						</ListItem>
					);
				})}
			</List>
		</ReccentPostWidget>
	);
}
